/* global $ */

$.ready(function() {
	/* global controller, loader */
	/* global spinClear, spinInit, spinReady, spinDone */
	
	var game = window.game = $('game');
	game.engine = 'slot';
	game.container = $.div('container').appendTo(game);
	game.controller = controller;
	
	game.dimensions = {
		width: 1920,
		height: 1080,
		font: 36,
		screen_width: 1920,
		screen_height: 1080,
	};
	
	loader.loadImages();
	loader.start('socket');
	loader.start('build');
	
	game.play = function() {
		if (game.panel.disabled) {
			return;
		}
		
		game.panel.disable('spin');
		game.panel.play.addClass('disabled');
		
		game.sounds.stop('win');
		game.panel.setWin(true);
		
		game.trigger('round_start', game.panel.getBet());
		
		var bet = game.panel.getBet();
		bet.bet = bet.coins;
		delete bet.coins;
		
		spinClear();
		game.spindle.spin();
		
		game.controller.socket.emit('spin', bet);
	};
	
	game.spin = function(response) {
		game.last = response;
		
		spinReady();
	};
	
	game.setTurbo = function(value) {
		this.turbo = !!value;
		
		if (value && game.spindle.stop > -1) {
			game.spindle.stop = -1;
		}
	};
	
	game.controller.socket.on('spin', function(response) {
		game.panel.play.removeClass('disabled');
		game.spin(response);
	});
	
	game.on('reable', function() {
		game.panel.play.removeClass('disabled');
	});
	
	game.controller.socket.on('open', function(config) {
		game.config = config;
		
		loader.stop('socket');
		
		game.trigger('ui', config);
		
		game.messaging.show('logo');
		game.panel.spin.update();
		game.panel.dialog.appendTo(game);
		
		game.sounds.loadSounds({
			reels: require('../sounds/reels.mp3'),
			bell: require('../sounds/bell.mp3'),
		});
		
		/* Recover / Recall */
		
		if (config.recover) {
			game.panel.disable('spin');
			
			var response = game.last = config.recover;
			
			if (typeof response.bet.bet !== 'undefined' && typeof response.bet.coins === 'undefined') {
				response.bet.coins = response.bet.bet;
				delete response.bet.bet;
			}
			
			game.panel.setBet(response.bet);
			game.pays.clear();
		}
		
		else if (config.recall) {
			var action = config.recall.actions[0];
			action.response.credits = config.credits;
			game.showRecall(action);
		}
		
		loader.stop('build');
	});
	
	game.on('ready', function() {
		game.sounds.play([ 'background' ], { loop: true });
		
		if (game.config.recover) {
			spinClear();
			spinInit();
			spinReady();
			spinDone();
			
			game.trigger('recover', game.config.recover);
		}
	});
});



/** WEBPACK FOOTER **
 ** ./../../public-src/common/js/core.js
 **/